import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppDownloadLinks } from '../common/AppDownloadLinks';
import './Hero.css';

export const Hero: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div>
          <h1 className="hero-title">{t('hero.title')}</h1>
          <p className="hero-subtitle">{t('hero.subtitle')}</p>
          <p className="hero-note">{t('hero.note')}</p>
          <div className="hero-cta">
            <AppDownloadLinks />
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-brand">
            <img src="/logo-red.svg" alt="" className="hero-logo" />
            <h2 className="hero-wordmark">care<span>umba</span></h2>
            <p className="hero-tagline">{t('hero.tagline')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
